import timezoneData from 'src/assets/files/timezone.json';

export interface CountryTimezone {
  countryCode: string;
  countryName: string;
  dialCode: string;
  timezones: string[];
}

export const COUNTRY_TIMEZONE_DATA: CountryTimezone[] = Object.entries(timezoneData).map(
  ([countryCode, data]) => {
    const rawCountryCode = (data as any).countryCode ?? '';

    // Extract only the "+digits" part from the countryCode
    const extractedCodeMatch = rawCountryCode.match(/\(\+(\d+)\)/);
    const cleanedCountryCode = extractedCodeMatch ? `+${extractedCodeMatch[1]}` : '';

    const mapped: CountryTimezone = {
      countryCode: cleanedCountryCode,
      countryName: (data as any).timezone,
      dialCode: (data as any).dialCode ?? '',
      timezones: (data as any).timezones ?? []
    };
    return mapped;
  }
);

  
  